unit InstrumentListScreenType;

{

/* Property CategoryList changed to CategoryItemList. */

/* Initial. */

}

interface

uses
  CategoryItemListType, InstrumentItemListType, SpecialismListType, SupplierItemListType;

type
  TInstrumentListScreenType = class
  private
    fInstrumentItemList: TInstrumentItemListType;
    fSupplierItemList: TSupplierItemListType;
    fSpecialismList: TSpecialismListType;
    fCategoryItemList: TCategoryItemListType;
  public
    property InstrumentItemList: TInstrumentItemListType read fInstrumentItemList;
    property SupplierItemList: TSupplierItemListType read fSupplierItemList;
    property SpecialismList: TSpecialismListType read fSpecialismList;
    property CategoryItemList: TCategoryItemListType read fCategoryItemList;
  end;

implementation

end.
